/**
 * @desc getCabinTODetailByCrno
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.CabinToDetailDataResponseDto>>;
export function request(
  params: API.tms.cabinMasterFacadeImpl.getCabinTODetailByCrno.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getCabinTODetailByCrno`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
